import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';

/**
 * Barra "support RuneAudio" in fondo ai post di ogni topic (prefooter_blocks.html del tema phpBB): tutta un link
 * alla pagina Support us del sito, con il bottone PayPal, le icone social e il gatto con gli stivali a destra.
 * Google+ non c'è più, come nel footer del sito.
 */
export default class SupportBlock extends Component {
  view() {
    const img = app.forum.attribute('assetsBaseUrl') + '/extensions/runeaudio-theme/img';
    return m("a", {
      className: "SupportBlock",
      href: "/support-us/",
      title: "Support us!",
      style: {
        '--support-image': `url('${img}/gato-con-botas.jpg')`
      }
    }, m("p", null, m("strong", null, m(Icon, {
      name: "fas fa-heart"
    }), " support RuneAudio"), m("span", {
      className: "SupportBlock-icons"
    }, m("img", {
      src: `${img}/paypal-btn.png`,
      alt: "Donate with PayPal",
      width: "99",
      height: "39"
    }), m(Icon, {
      name: "fab fa-facebook-f"
    }), m(Icon, {
      name: "fab fa-x-twitter"
    }), m(Icon, {
      name: "fab fa-github"
    }))));
  }
}
flarum.reg.add('runeaudio-theme', 'forum/components/SupportBlock', SupportBlock);